module.exports = __webpack_public_path__ + "static/media/gsuite-top-senders.e820017b.png";